// src/marketing/components/PageWrapper.js
import React from 'react';
import MarketingNavigation from './Navigation';
import MarketingCTA from './CTA';
import MarketingFooter from './Footer';

const PageWrapper = ({
  children,
  showNavigation = true,
  showFooter = true,
  showCTA = true,
  ctaProps = {}, // Allow customizing CTA per page
}) => {
  return (
    <div className="min-h-screen">
      {showNavigation && <MarketingNavigation />}

      <main className={showNavigation ? 'pt-20' : ''}>{children}</main>

      {showCTA && <MarketingCTA {...ctaProps} />}
      {showFooter && <MarketingFooter />}
    </div>
  );
};

export default PageWrapper;
